/**
Item: Page where components for Import are placed. Can be found in Fachadministrator -> Import
Name: ImportPage
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { InputMask } from 'primereact/inputmask';
import Upload from '../components/Upload';
import { DropdownLabeled } from '../components/DropdownLabeled';
import MessageService from '../service/MessageService';

export default class ImportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value1: '',
      formValues: {
        importNewFlag: false,
        importModifyFlag: false,
        importMode: 'NEW',
        deleteTimeSlicesFirst: false,
        dataSelection: '',
        importMetadata: false,
        importDataset: false,
        importPTable: false,
        lockTimeSlice: false,
        buildThesaurusAfterImport: false,
        multilingual: false,
        modus: 'BATCH',
        startDate: '',
        startTime: '',
        startTimeFlag: false,
        endTime: '',
        endTimeFlag: false,
        userName: '',
        charset: 'UTF-8',
        optionsOwnerName: [],
        ownerName: '',
        rightsSelection: 'OFFICE',
      },
    };
    this.messageService = new MessageService();
    this.checkDate = this.checkDate.bind(this);
  }

  componentDidMount = async () => {
    const role = sessionStorage.getItem('role');
    const isSuperAdmin = role === 'SUPER_SUBJECT_ADMIN';
    if (isSuperAdmin) {
      const userData = await this.messageService.postAdminList();
      const { entrys } = userData.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      const optionsOwnerName = [{ label: '-', value: undefined }];
      for (let i = 0; i < entrys.length; i += 1) {
        const option = {
          label: `${entrys[i].fullName} (${entrys[i].name})`,
          value: entrys[i].name,
        };
        optionsOwnerName.push(option);
      }
      this.setState({ optionsOwnerName });
    }
  }

  switchFormRadio(value, source) {
    const { formValues } = this.state;
    if (source === 1) {
      formValues.rightsSelection = value;
    } else if (source === 2) {
      formValues.charset = value;
    } else {
      if (value === 'Regeln') {
        formValues.importModifyFlag = false;
        if (!formValues.rightsSelection) formValues.rightsSelection = 'OFFICE';
      } else {
        formValues.importNewFlag = true;
        formValues.importModifyFlag = false;
        formValues.rightsSelection = '';
      }
      formValues.dataSelection = value;
    }
    this.setState({ formValues });
  }

  switchFormValue(valueName, itemValue) {
    // const tmp = this.state.formValues;
    const { formValues } = this.state;
    formValues[valueName] = itemValue;
    if (valueName === 'startTime') {
      formValues[`${valueName}Flag`] = itemValue !== '';
    }
    if (valueName === 'endTime') { // adjust endTime date if it is before startTime
      formValues[`${valueName}Flag`] = itemValue !== '';
    }
    this.setState({ formValues });
    console.log('VAL#1', formValues);
  }

  handleOwnerNameChange(e) {
    const { formValues } = this.state;
    formValues.ownerName = e.value;
    this.setState({ ownerName: e.value, formValues });
  }

  checkDate(str) {
    const { formValues } = this.state;
    const year = str.substring(6, 10);
    let ret = true;
    if (year > 2100) {
      formValues.startTime = '';
      this.setState({ formValues });
      this.growl.show({
        life: 12000, severity: 'error', summary: 'Fehler', detail: 'Datum liegt zu weit in der Zukunft',
      });
      ret = false;
    }
    if (!this.isDateTimeGerman(str)) {
      formValues.startTime = '';
      this.setState({ formValues });
      this.growl.show({
        life: 12000, severity: 'error', summary: 'Fehler', detail: 'Ungültiges Datum',
      });
      ret = false;
    }
    return ret;
  }

  isDateTimeGerman(str) {
    const testStr = str + ':00'
    let regex = /(0?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|[1][0-2])\.[0-9]+ (0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9])+:(0?[0-9]|[1-5][0-9])/i;
    return regex.test(testStr);
    console.log('VAL#2', dateRegex.test(testStr));
  }

  async loadAdminList(functionName, direction, entries, maxRowsPerPage) {
    const {
      sortCriterion, sortDirection, searchCriterion, searchText,
    } = this.state;
    const userData = await this.messageService.postAdminList(
      functionName,
      direction,
      entries,
      maxRowsPerPage,
      sortCriterion,
      sortDirection,
      searchCriterion.value,
      searchText,
    );
    return;
    if (userData.entrys) {
      if (userData.entrys.length > 0) {
        this.setState({
          userData: userData.entrys,
        });
      } else {
        this.showMessage('Es wurden keine weiteren Einträge gefunden.', 'info');
      }
    }
    if (userData[1] === 'error') {
      this.showMessage(userData[0], 'error');
      // reset search criteria
      this.setState({ searchText: '' });
      // start default search
    }
  }

  render() {
    const role = sessionStorage.getItem('role');
    const group = sessionStorage.getItem('group');
    const isAdmin = role === 'GROUP_ADMIN';
    const isSysAdmin = role === 'SYSTEM_ADMIN';
    const isSuperAdmin = role === 'SUPER_SUBJECT_ADMIN';
    const isStBA = group === 'StBA';
    if (!(isSysAdmin || isSuperAdmin || (isAdmin && isStBA))) {
      window.location.replace('./');
      return;
    }
    const { formValues, optionsOwnerName, ownerName } = this.state;
    const dataDisabled = formValues.dataSelection !== 'Metadaten' && formValues.dataSelection !== 'Regeln' && formValues.dataSelection !== 'Datenquader';
    const dataColor = formValues.dataSelection !== 'Metadaten' && formValues.dataSelection !== 'Regeln' && formValues.dataSelection !== 'Datenquader' ? '#CECECE' : '#212121';
    // const rightsDisabled = formValues.dataSelection !== 'Regeln';
    const rightsDisabled = false;
    const rightsDisabledGrp = (!ownerName);
    // const rightColor = formValues.dataSelection !== 'Regeln' ? '#CECECE' : '#212121';
    const rightColor = '#212121';
    let timeSelect = (
      <Card title="Früheste Startzeit des Imports">
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <div className="p-grid" style={{ marginBottom: '10px' }}>
              <div className="p-col-6">
                <InputMask
                  mask="99.99.9999 99:99"
                  slotChar="dd.mm.yyyy __.__"
                  value={formValues.startTime}
                  onChange={(e) => this.switchFormValue('startTime', e.value)}
                  onComplete={() => this.checkDate(formValues.startTime)}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
    let importSelect = (
      <Card title="Fremdimport">
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <div className="p-grid" style={{ marginBottom: '10px' }}>
              <div className="p-col-12">
                <DropdownLabeled
                  id="ownerName"
                  label="Benutzer für Fremdimport"
                  name="ownerName"
                  options={optionsOwnerName}
                  value={ownerName}
                  onChange={(e) => this.handleOwnerNameChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
    if (!isSuperAdmin) timeSelect = undefined;
    if (!isSuperAdmin) importSelect = undefined;
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-lg-6">
          <Card title="Importdatei">
            <div className="content-section implementation">
              <Upload
                formValues={formValues}
                checkDate={this.checkDate}
              />
              <Growl
                ref={(el) => {
                  this.growl = el;
                }}
              />
            </div>
          </Card>
          <Card title="Datenübernahme">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-lg-6">
                <Checkbox
                  id="importNewFlag"
                  checked={formValues.importNewFlag}
                  onChange={(e) => this.switchFormValue('importNewFlag', e.checked)}
                />
                <label htmlFor="cb1" className="p-checkbox-label">
                  Daten neu übernehmen
                </label>
                <br />
                <br />
                <Checkbox
                  id="importModifyFlag"
                  checked={formValues.importModifyFlag}
                  onChange={(e) => this.switchFormValue('importModifyFlag', e.checked)}
                  disabled={dataDisabled && formValues.dataSelection !== ''}
                />
                <label htmlFor="cb2" className="p-checkbox-label">
                  {dataDisabled && formValues.dataSelection !== '' ? <span style={{ color: '#CECECE' }}>
                    Vorhandene Daten überschreiben
                    </span> : 'Vorhandene Daten überschreiben'}
                </label>
              </div>
              <div className="p-col-12 p-lg-6">
                <Checkbox
                  id="deleteTimeSlicesFirst"
                  checked={formValues.deleteTimeSlicesFirst}
                  onChange={(e) => this.switchFormValue('deleteTimeSlicesFirst', e.checked)}
                />
                <label htmlFor="cb3" className="p-checkbox-label">
                  Zeitscheiben zuerst löschen
                </label>
              </div>
            </div>
          </Card>
          <Card title="Inhalte des Imports">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-lg-6">
                <div className="p-grid" style={{ width: '250px', marginBottom: '10px' }}>
                  <div className="p-col-12">
                    <RadioButton inputId="rb1" name="city" value="Metadaten" onChange={(e) => this.switchFormRadio(e.value)} checked={formValues.dataSelection === 'Metadaten'} />
                    <label htmlFor="rb1" className="p-radiobutton-label">Metadaten</label>
                  </div>
                  <div className="p-col-12">
                    <RadioButton inputId="rb5" name="inhalt" value="Datenquader" onChange={(e) => this.switchFormRadio(e.value)} checked={formValues.dataSelection === 'Datenquader'} />
                    <label htmlFor="rb5" className="p-radiobutton-label">Datenquader/-Werte</label>
                  </div>
                  <div className="p-col-12">
                    <RadioButton inputId="rb4" name="city" value="Regeln" onChange={(e) => this.switchFormRadio(e.value)} checked={formValues.dataSelection === 'Regeln'} />
                    <label htmlFor="rb4" className="p-radiobutton-label">Regeln</label>
                  </div>
                  <div className="p-col-12">
                    <RadioButton inputId="rb2" name="city" value="Wertedaten" onChange={(e) => this.switchFormRadio(e.value)} checked={formValues.dataSelection === 'Wertedaten'} />
                    <label htmlFor="rb2" className="p-radiobutton-label">Wertedaten</label>
                  </div>
                  <div className="p-col-12">
                    <RadioButton inputId="rb3" name="city" value="PTable" onChange={(e) => this.switchFormRadio(e.value)} checked={formValues.dataSelection === 'PTable'} />
                    <label htmlFor="rb3" className="p-radiobutton-label">PTable</label>
                  </div>
                </div>
              </div>
              <div className="p-col-12 p-lg-6">
                <Checkbox
                  id="lockTimeSlice"
                  checked={formValues.lockTimeSlice}
                  onChange={(e) => this.switchFormValue('lockTimeSlice', e.checked)}
                />
                <label htmlFor="cb6" className="p-checkbox-label">
                  Zeitscheiben sperren
                </label>
              </div>
            </div>
          </Card>
          <Card title="Rechtebereich" style={{ color: rightColor }}>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-lg-3">
                <div className="p-grid" style={{ width: '250px', marginBottom: '10px' }}>
                  <div className="p-col-12">
                    <RadioButton
                      disabled={rightsDisabled}
                      inputId="right2"
                      name="rights"
                      value="BEN"
                      onChange={(e) => this.switchFormRadio(e.value, 1)}
                      checked={formValues.rightsSelection === 'BEN'}
                    />
                    <label htmlFor="right3" className="p-radiobutton-label">Benutzer</label>
                  </div>
                </div>
              </div>
              <div className="p-col-12 p-lg-3">
                <div className="p-grid" style={{ width: '250px', marginBottom: '10px' }}>
                  <div className="p-col-12">
                    <RadioButton
                      disabled={rightsDisabledGrp}
                      inputId="right4"
                      name="rights"
                      value="GRP"
                      onChange={(e) => this.switchFormRadio(e.value, 1)}
                      checked={formValues.rightsSelection === 'GRP'}
                    />
                    <label htmlFor="right4" className="p-radiobutton-label">gruppenintern</label>
                  </div>
                </div>
              </div>
              <div className="p-col-12 p-lg-3">
                <div className="p-grid" style={{ width: '250px', marginBottom: '10px' }}>
                  <div className="p-col-12">
                    <RadioButton
                      disabled={rightsDisabled}
                      inputId="right1"
                      name="rights"
                      value="OFFICE"
                      onChange={(e) => this.switchFormRadio(e.value, 1)}
                      checked={formValues.rightsSelection === 'OFFICE'}
                    />
                    <label htmlFor="right2" className="p-radiobutton-label">amtsintern</label>
                  </div>
                </div>
              </div>
              <div className="p-col-12 p-lg-3">
                <div className="p-grid" style={{ width: '250px', marginBottom: '10px' }}>
                  <div className="p-col-12">
                    <RadioButton
                      disabled={rightsDisabled}
                      inputId="right3"
                      name="rights"
                      value="FREE"
                      onChange={(e) => this.switchFormRadio(e.value, 1)}
                      checked={formValues.rightsSelection === 'FREE'}
                    />
                    <label htmlFor="right2" className="p-radiobutton-label">öffentlich</label>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          {timeSelect}
          {importSelect}
        </div>
        <div className="p-col-12 p-lg-6">
          <Card title="Hinweis zur Importreihenfolge">
            Die logischen Abhängigkeiten zwischen Daten sind beim Import zu beachten.
            Der Import der Meta- und Wertedaten erfolgt in einer fest definierten Reihenfolge.
            Diese gewährleistet, dass die aufgrund der Abhängigkeiten zwischen den Objekten
            notwendigen Referenzen vorhanden sind und die komplexen Prüfungen der zu
            importierenden Daten fehlerfrei durchgeführt werden können.
            Zu importierende Daten können auf einzelne Importdateien verteilt werden. Wird nur eine
            Datei verwendet, muss innerhalb der Datei die Reihenfolge der Metadaten strikt
            eingehalten werden.
            <p />
            Sequentielle sinnvolle Abfolge der Importe von Metadaten (einzelne können auch
            übersprungen oder mehrfach ausgeführt werden):
            <p />

            <ol>
              <li>(Statistik)</li>
              <li>Merkmal</li>
              <li>Ausprägung</li>
              <li>Statistikdurchführung</li>
              <li>Statistikmerkmal</li>
              <li>Statistikdurchführungsmerkmal</li>
              <li>Ausprägungszuordnung</li>
              <li>Gültigkeit der Ausprägungszuordnung</li>
              <li>Maßeinheit</li>
              <li>Verschlüsselung</li>
              <li>Verschlüsselungsausprägungszuordnung</li>
              <li>Datensatzaufbau</li>
              <li>Datenfeldgruppe</li>
              <li>Datei</li>
              <li>Datenfeld</li>
            </ol>
            Nachfolgend ist die Abhängigkeit der Metadaten voneinander dargestellt:
            <p />
            <p />
            <img src={`${process.env.PUBLIC_URL}/assets/layout/images/importHint.PNG`} width="100%" alt="Grafik Importreihenfolge" />
          </Card>
        </div>
      </div>
    );
  }
}
